import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6428a09a = () => interopDefault(import('../pages/akb48.vue' /* webpackChunkName: "pages/akb48" */))
const _63d4e471 = () => interopDefault(import('../pages/certification.vue' /* webpackChunkName: "pages/certification" */))
const _3d2e8f49 = () => interopDefault(import('../pages/cix.vue' /* webpackChunkName: "pages/cix" */))
const _724374c0 = () => interopDefault(import('../pages/codes/index.vue' /* webpackChunkName: "pages/codes/index" */))
const _8507ac1c = () => interopDefault(import('../pages/events.vue' /* webpackChunkName: "pages/events" */))
const _645050e6 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _1fabcb0a = () => interopDefault(import('../pages/garally/index.vue' /* webpackChunkName: "pages/garally/index" */))
const _4fdcb3c7 = () => interopDefault(import('../pages/how.vue' /* webpackChunkName: "pages/how" */))
const _9db5c63c = () => interopDefault(import('../pages/Instructions.pdf.vue' /* webpackChunkName: "pages/Instructions.pdf" */))
const _946285fa = () => interopDefault(import('../pages/jo1.vue' /* webpackChunkName: "pages/jo1" */))
const _a67e6c3e = () => interopDefault(import('../pages/junk.vue' /* webpackChunkName: "pages/junk" */))
const _324a1ea0 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _b620abec = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _66c6bbd8 = () => interopDefault(import('../pages/mypage.vue' /* webpackChunkName: "pages/mypage" */))
const _4df60c7c = () => interopDefault(import('../pages/niziu.vue' /* webpackChunkName: "pages/niziu" */))
const _7181a4ce = () => interopDefault(import('../pages/offline_events.vue' /* webpackChunkName: "pages/offline_events" */))
const _126e5f7f = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _74a07b0c = () => interopDefault(import('../pages/registerCodes.vue' /* webpackChunkName: "pages/registerCodes" */))
const _1164e986 = () => interopDefault(import('../pages/reset.vue' /* webpackChunkName: "pages/reset" */))
const _d160e5c4 = () => interopDefault(import('../pages/seventeen.vue' /* webpackChunkName: "pages/seventeen" */))
const _77fed034 = () => interopDefault(import('../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _7030694d = () => interopDefault(import('../pages/straykids.vue' /* webpackChunkName: "pages/straykids" */))
const _693910a6 = () => interopDefault(import('../pages/streamings/index.vue' /* webpackChunkName: "pages/streamings/index" */))
const _4a7a4046 = () => interopDefault(import('../pages/support.vue' /* webpackChunkName: "pages/support" */))
const _12a039be = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _40f1c3f0 = () => interopDefault(import('../pages/thegazette.vue' /* webpackChunkName: "pages/thegazette" */))
const _4208b022 = () => interopDefault(import('../pages/twice/index.vue' /* webpackChunkName: "pages/twice/index" */))
const _7347a2da = () => interopDefault(import('../pages/upload.vue' /* webpackChunkName: "pages/upload" */))
const _98f553c2 = () => interopDefault(import('../pages/app/faq.vue' /* webpackChunkName: "pages/app/faq" */))
const _358a3259 = () => interopDefault(import('../pages/app/how.vue' /* webpackChunkName: "pages/app/how" */))
const _51364511 = () => interopDefault(import('../pages/app/privacy.vue' /* webpackChunkName: "pages/app/privacy" */))
const _ed7bb450 = () => interopDefault(import('../pages/app/support.vue' /* webpackChunkName: "pages/app/support" */))
const _42e85bd0 = () => interopDefault(import('../pages/app/terms.vue' /* webpackChunkName: "pages/app/terms" */))
const _39a418e2 = () => interopDefault(import('../pages/codes/casts.vue' /* webpackChunkName: "pages/codes/casts" */))
const _2d93dc5a = () => interopDefault(import('../pages/codes/dates.vue' /* webpackChunkName: "pages/codes/dates" */))
const _26b9a2bb = () => interopDefault(import('../pages/codes/events.vue' /* webpackChunkName: "pages/codes/events" */))
const _387ec5f6 = () => interopDefault(import('../pages/codes/groups.vue' /* webpackChunkName: "pages/codes/groups" */))
const _7431ad24 = () => interopDefault(import('../pages/codes/organizations.vue' /* webpackChunkName: "pages/codes/organizations" */))
const _ef6365c4 = () => interopDefault(import('../pages/codes/select.vue' /* webpackChunkName: "pages/codes/select" */))
const _b241d06c = () => interopDefault(import('../pages/external/entry/index.vue' /* webpackChunkName: "pages/external/entry/index" */))
const _1d42306a = () => interopDefault(import('../pages/garally/photo.vue' /* webpackChunkName: "pages/garally/photo" */))
const _3e14f41e = () => interopDefault(import('../pages/lottery/confirm.vue' /* webpackChunkName: "pages/lottery/confirm" */))
const _61c345db = () => interopDefault(import('../pages/lottery/select.vue' /* webpackChunkName: "pages/lottery/select" */))
const _202e45df = () => interopDefault(import('../pages/signup/detail.vue' /* webpackChunkName: "pages/signup/detail" */))
const _44546fb6 = () => interopDefault(import('../pages/streamings/help.vue' /* webpackChunkName: "pages/streamings/help" */))
const _e2620522 = () => interopDefault(import('../pages/event/lottery/campaign/_id.vue' /* webpackChunkName: "pages/event/lottery/campaign/_id" */))
const _2e7bcfb6 = () => interopDefault(import('../pages/event/lottery/_id.vue' /* webpackChunkName: "pages/event/lottery/_id" */))
const _5bfe1164 = () => interopDefault(import('../pages/gacha/_id.vue' /* webpackChunkName: "pages/gacha/_id" */))
const _72078f2a = () => interopDefault(import('../pages/lottery/_id.vue' /* webpackChunkName: "pages/lottery/_id" */))
const _6f2ef418 = () => interopDefault(import('../pages/streamings/_id/index.vue' /* webpackChunkName: "pages/streamings/_id/index" */))
const _2fa31b32 = () => interopDefault(import('../pages/top/_name.vue' /* webpackChunkName: "pages/top/_name" */))
const _e61cfef0 = () => interopDefault(import('../pages/streamings/_id/archive.vue' /* webpackChunkName: "pages/streamings/_id/archive" */))
const _0cae2aa8 = () => interopDefault(import('../pages/streamings/_id/administrator/internal/index.vue' /* webpackChunkName: "pages/streamings/_id/administrator/internal/index" */))
const _60c8221c = () => interopDefault(import('../pages/streamings/_id/administrator/internal/archive.vue' /* webpackChunkName: "pages/streamings/_id/administrator/internal/archive" */))
const _68a27b89 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/akb48",
    component: _6428a09a,
    name: "akb48"
  }, {
    path: "/certification",
    component: _63d4e471,
    name: "certification"
  }, {
    path: "/cix",
    component: _3d2e8f49,
    name: "cix"
  }, {
    path: "/codes",
    component: _724374c0,
    name: "codes"
  }, {
    path: "/events",
    component: _8507ac1c,
    name: "events"
  }, {
    path: "/faq",
    component: _645050e6,
    name: "faq"
  }, {
    path: "/garally",
    component: _1fabcb0a,
    name: "garally"
  }, {
    path: "/how",
    component: _4fdcb3c7,
    name: "how"
  }, {
    path: "/Instructions.pdf",
    component: _9db5c63c,
    name: "Instructions.pdf"
  }, {
    path: "/jo1",
    component: _946285fa,
    name: "jo1"
  }, {
    path: "/junk",
    component: _a67e6c3e,
    name: "junk"
  }, {
    path: "/login",
    component: _324a1ea0,
    name: "login"
  }, {
    path: "/maintenance",
    component: _b620abec,
    name: "maintenance"
  }, {
    path: "/mypage",
    component: _66c6bbd8,
    name: "mypage"
  }, {
    path: "/niziu",
    component: _4df60c7c,
    name: "niziu"
  }, {
    path: "/offline_events",
    component: _7181a4ce,
    name: "offline_events"
  }, {
    path: "/privacy",
    component: _126e5f7f,
    name: "privacy"
  }, {
    path: "/registerCodes",
    component: _74a07b0c,
    name: "registerCodes"
  }, {
    path: "/reset",
    component: _1164e986,
    name: "reset"
  }, {
    path: "/seventeen",
    component: _d160e5c4,
    name: "seventeen"
  }, {
    path: "/signup",
    component: _77fed034,
    name: "signup"
  }, {
    path: "/straykids",
    component: _7030694d,
    name: "straykids"
  }, {
    path: "/streamings",
    component: _693910a6,
    name: "streamings"
  }, {
    path: "/support",
    component: _4a7a4046,
    name: "support"
  }, {
    path: "/terms",
    component: _12a039be,
    name: "terms"
  }, {
    path: "/thegazette",
    component: _40f1c3f0,
    name: "thegazette"
  }, {
    path: "/twice",
    component: _4208b022,
    name: "twice"
  }, {
    path: "/upload",
    component: _7347a2da,
    name: "upload"
  }, {
    path: "/app/faq",
    component: _98f553c2,
    name: "app-faq"
  }, {
    path: "/app/how",
    component: _358a3259,
    name: "app-how"
  }, {
    path: "/app/privacy",
    component: _51364511,
    name: "app-privacy"
  }, {
    path: "/app/support",
    component: _ed7bb450,
    name: "app-support"
  }, {
    path: "/app/terms",
    component: _42e85bd0,
    name: "app-terms"
  }, {
    path: "/codes/casts",
    component: _39a418e2,
    name: "codes-casts"
  }, {
    path: "/codes/dates",
    component: _2d93dc5a,
    name: "codes-dates"
  }, {
    path: "/codes/events",
    component: _26b9a2bb,
    name: "codes-events"
  }, {
    path: "/codes/groups",
    component: _387ec5f6,
    name: "codes-groups"
  }, {
    path: "/codes/organizations",
    component: _7431ad24,
    name: "codes-organizations"
  }, {
    path: "/codes/select",
    component: _ef6365c4,
    name: "codes-select"
  }, {
    path: "/external/entry",
    component: _b241d06c,
    name: "external-entry"
  }, {
    path: "/garally/photo",
    component: _1d42306a,
    name: "garally-photo"
  }, {
    path: "/lottery/confirm",
    component: _3e14f41e,
    name: "lottery-confirm"
  }, {
    path: "/lottery/select",
    component: _61c345db,
    name: "lottery-select"
  }, {
    path: "/signup/detail",
    component: _202e45df,
    name: "signup-detail"
  }, {
    path: "/streamings/help",
    component: _44546fb6,
    name: "streamings-help"
  }, {
    path: "/event/lottery/campaign/:id?",
    component: _e2620522,
    name: "event-lottery-campaign-id"
  }, {
    path: "/event/lottery/:id?",
    component: _2e7bcfb6,
    name: "event-lottery-id"
  }, {
    path: "/gacha/:id?",
    component: _5bfe1164,
    name: "gacha-id"
  }, {
    path: "/lottery/:id?",
    component: _72078f2a,
    name: "lottery-id"
  }, {
    path: "/streamings/:id",
    component: _6f2ef418,
    name: "streamings-id"
  }, {
    path: "/top/:name?",
    component: _2fa31b32,
    name: "top-name"
  }, {
    path: "/streamings/:id/archive",
    component: _e61cfef0,
    name: "streamings-id-archive"
  }, {
    path: "/streamings/:id/administrator/internal",
    component: _0cae2aa8,
    name: "streamings-id-administrator-internal"
  }, {
    path: "/streamings/:id/administrator/internal/archive",
    component: _60c8221c,
    name: "streamings-id-administrator-internal-archive"
  }, {
    path: "/",
    component: _68a27b89,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
